import { LOCALSTORAGESTRINGS } from "src/app/core/models/masters/localstorage.enum";
import { Component, OnDestroy, OnInit, ViewEncapsulation, HostListener } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "src/environments/environment";
import { TutotrialDataLocal } from "../../models/tuturial/tutorial.model";
import { User } from "../../models/users/user.models";
import { LoginService } from "../../services/login";
import { LocalStorage } from "../../utils/local-storage";
import { Utils } from "../../utils/utils";
import { GraphService } from "../../services/graph/graph.service";
import { TargetsService } from "../../services/targets";
import { SigmaToolbarsService } from "../../services/sigma-toolbars/sigma-toolbars.service";
import { ModalTutorialUserComponent } from "src/app/shared/components/modal-tutorial-user/modal-tutorial-user.component";
import { MODAL_DIALOG_TYPES } from "../../utils/modal-dialog-types";
import { NbToggleModule } from "@nebular/theme";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { MastersService } from "../../services/masters";
import { availableProfiles } from "src/app/store/models/profiles.model";
import { Store } from "@ngrx/store";
import { State } from "src/app/store/models/store.model";
import { LccModel } from "../../models/groups/lcc-model";
import { GruposService } from "../../services/groups/grupos.service";
import { SOCKETMESSAGES } from "../../models/socket/socket.constants";
import { SocketService } from "../../services/socket/socket-service.service";
import { Subject, Subscription, takeUntil } from "rxjs";
import { TutorialModalService } from "../../services/shared/tutorial.modal.service";
@Component({
	selector: "app-side-bar",
	templateUrl: "./side-bar.component.html",
	styleUrls: ["./side-bar.component.scss"],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class SideBarComponent implements OnInit, OnDestroy {
	private destroy$ = new Subject<void>();
	public arrayValues: number[] = [];
	public usuario: User;
	public user: User;

	profilesOfUser: availableProfiles;
	public isModalOpen: boolean = false;
	public isVideoModalOpen: boolean = false;
	public videoList: any[] = [];
	public selectedVideoIndex: number | null = null;
	public videoUrl: SafeResourceUrl | null = null;

	modalPosition = { top: 150, left: 120 }; // Modal principal
	videoModalPosition = { top: 350, left: 250 }; // Modal de video

	isDraggingMain = false;
	isDraggingVideo = false;
	showIconAgent = false;

	dragStartMain = { x: 0, y: 0 };
	dragStartVideo = { x: 0, y: 0 };

	intervalId: NodeJS.Timeout;
	idTutorialContent_aux: number = 0;

	cpPosition: any;
	sidebarData: boolean;
	urlTutorial: string = environment.tutorial;
	graphVisited_Student: [] = [];
	graphVisited_Editor: [] = [];
	lastTarget: number;
	lastTarget_Editor: number;

	newMessageChat: boolean = false;
	tutorialesActivos: boolean = false;
	isMobile: boolean = true;
	isModalFirst: boolean;

	public constructor(
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private modalService: NgbModal,
		public translateService: TranslateService,
		public loginService: LoginService,
		public localStorage: LocalStorage,
		private localStorageService: LocalStorage,
		private utils: Utils,
		private graphServ: GraphService,
		public targetsService: TargetsService,
		public toolsService: SigmaToolbarsService,
		private masterService: MastersService,
		private sanitizer: DomSanitizer,
		private store: Store<State>,
		private groupService: GruposService,
		private tutorialService: TutorialModalService
	) {
		this.user = this.loginService.getUser();
		this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
			// De esta forma cada vez que cambia el parametro lo actualizo
			this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		});
		this.tutorialesActivos =
			this.localStorage.getItem("TutorialesON") == "true" ? true : false;
		this.localStorage.setItem("firstStepStudent", "true");
	}

	public get shouldShowAvatar(): boolean {
		if (!this.loginService.esEstudiante()) {
			return true;
		}

		const isFirstStep =
			this.localStorage.getItem("firstStepStudent") === "true";
		if (isFirstStep) {
			return true;
		}

		if (this.isMobile) {
			const showOnce = this.localStorage.getItem("showAvatarOnce") === "true";

			if (showOnce) {
				this.localStorage.setItem("showAvatarOnce", "false");
				return true;
			}
			return false;
		} else {
			const enClase = this.localStorage.getItem("enClase") === "true";
			return !enClase;
		}
	}

	public ngOnInit() {
		this.isMobile = window.innerWidth < 768;
		this._traducirOpciones();
		this.tutorialDisponible();
		// obtenemos la info del grafo visto anteriormente
		this.obtainLastTargetsVisited();

		// Escuchar los cambios en el estado del modal
		this.masterService.tutorialModalData$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
			if (this.tutorialesActivos) {
				this.isModalOpen = data.isOpen;
				this.videoList = data.videos;
			}
		});

		this.startInterval();
		this.store
			.select((store) => store.profiles)
			.pipe(takeUntil(this.destroy$))
			.subscribe((profiles) => {
				this.profilesOfUser = profiles;
			});
		//PARA EL CHAT
		this.groupService.refreshMessages$
			.pipe(takeUntil(this.destroy$))
			.subscribe(() => {
				this.newMessageChat = true;
			});
		/**
		//solo mostramos el tutorial si el usuario es neuvo
		if (this.user.isMature == 0 && !this.isMobile) {
			this.verTutoriales()
		}
			*/
		this.tutorialService.verTutoriales$.pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.verTutoriales();
		});
	}

	public openVideoModal(index: number, url: string): void {
		this.selectedVideoIndex = index;
		this.videoUrl = this.sanitizeUrl(this.getEmbedUrl(url));
		this.isVideoModalOpen = true;
	}

	public closeVideoModal(): void {
		this.selectedVideoIndex = null;
		this.videoUrl = null;
		this.isVideoModalOpen = false;
	}

	// Inicia el arrastre para el modal correspondiente
	startDragging(event: MouseEvent, modalType: "main" | "video") {
		if (modalType === "main") {
			this.isDraggingMain = true;
			this.dragStartMain = {
				x: event.clientX - this.modalPosition.left,
				y: event.clientY - this.modalPosition.top,
			};
			document.addEventListener("mousemove", this.dragModalMain);
			document.addEventListener("mouseup", this.stopDraggingMain);
		} else if (modalType === "video") {
			this.isDraggingVideo = true;
			this.dragStartVideo = {
				x: event.clientX - this.videoModalPosition.left,
				y: event.clientY - this.videoModalPosition.top,
			};
			document.addEventListener("mousemove", this.dragModalVideo);
			document.addEventListener("mouseup", this.stopDraggingVideo);
		}
	}

	// Arrastre del modal principal
	dragModalMain = (event: MouseEvent) => {
		if (!this.isDraggingMain) return;
		this.modalPosition = {
			top: event.clientY - this.dragStartMain.y,
			left: event.clientX - this.dragStartMain.x,
		};
	};

	// Arrastre del modal de video
	dragModalVideo = (event: MouseEvent) => {
		if (!this.isDraggingVideo) return;
		this.videoModalPosition = {
			top: event.clientY - this.dragStartVideo.y,
			left: event.clientX - this.dragStartVideo.x,
		};
	};

	// Detener el arrastre del modal principal
	stopDraggingMain = () => {
		this.isDraggingMain = false;
		document.removeEventListener("mousemove", this.dragModalMain);
		document.removeEventListener("mouseup", this.stopDraggingMain);
	};

	// Detener el arrastre del modal de video
	stopDraggingVideo = () => {
		this.isDraggingVideo = false;
		document.removeEventListener("mousemove", this.dragModalVideo);
		document.removeEventListener("mouseup", this.stopDraggingVideo);
	};

	public toggleVideoPlayer(index: number, url: string | null): void {
		if (this.selectedVideoIndex === index) {
			// Cerrar el reproductor si ya está abierto
			this.selectedVideoIndex = null;
			this.videoUrl = null;
		} else {
			// Abrir el reproductor para el video seleccionado
			this.selectedVideoIndex = index;
			this.videoUrl = url ? this.sanitizeUrl(this.getEmbedUrl(url)) : null;
		}
	}

	public getVideoId(url: string): string {
		const videoIdMatch = url.match(
			/(?:https?:\/\/(?:www\.)?youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/
		);
		return videoIdMatch ? videoIdMatch[1] : "";
	}

	public getEmbedUrl(url: string): string {
		const videoId = this.getVideoId(url);
		return `https://www.youtube.com/embed/${videoId}`;
	}

	private sanitizeUrl(url: string): SafeResourceUrl {
		return this.sanitizer.bypassSecurityTrustResourceUrl(url);
	}

	public closeModal(): void {
		// Cerrar el modal notificando al servicio
		this.masterService.closeModal();
		this.isModalOpen = false;
		this.selectedVideoIndex = null;
		this.videoUrl = null;
	}

	@HostListener("window:resize", ["$event"])
	onResize(event: any): void {
		if (window.innerWidth <= 768) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	private startInterval(): void {
		if (this.intervalId) {
			clearInterval(this.intervalId);
		}
		this.intervalId = setInterval(() => {
			let idTutorialContext = this.localStorage.getItem("idTutorialContext");
			if (this.isModalOpen && idTutorialContext != this.idTutorialContent_aux) {
				this.idTutorialContent_aux = idTutorialContext;
				// Cerrar el reproductor si ya está abierto
				this.selectedVideoIndex = null;
				// Escuchar los cambios en el estado del modal
				this.masterService
					.getVideosForContext(idTutorialContext)
					.pipe(takeUntil(this.destroy$))
					.subscribe((res) => {
						if (res.data && res.data.length > 0) {
							// Emitir los datos y abrir el modal
							this.videoList = res.data;
						}
					});
			}
		}, 2000);
	}

	obtainLastTargetsVisited() {
		this.graphVisited_Student = JSON.parse(this.localStorage.getItem("graphVisited_Student")) || [];
		this.graphVisited_Editor = JSON.parse(this.localStorage.getItem("graphVisited_Editor")) || [];
		this.lastTarget = JSON.parse(this.localStorage.getItem("lastTarget")); //idTarget del grafo actual
		this.lastTarget_Editor = JSON.parse(this.localStorage.getItem("lastTarget_Editor"));
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
		if (this.intervalId) {
			clearInterval(this.intervalId);
			this.intervalId = null;
		}
		// Limpiar listeners de drag por si quedan activos
		document.removeEventListener("mousemove", this.dragModalMain);
		document.removeEventListener("mouseup", this.stopDraggingMain);
		document.removeEventListener("mousemove", this.dragModalVideo);
		document.removeEventListener("mouseup", this.stopDraggingVideo);
	}

	tutorialDisponible() {
		if (this.loginService.comprobarTutorial()) {
			let canvasGrafoTutorial = JSON.parse(
				this.localStorageService.getItem(LOCALSTORAGESTRINGS.TUTORIALDATA)
			) as TutotrialDataLocal;
			this.sidebarData = canvasGrafoTutorial.sideBarData;
			this.abrirTutorial();
		} else {
			this.sidebarData = true;
		}
	}

	abrirTutorial() {
		if (!this.sidebarData) {
			setTimeout(() => {
				this.initPosition(10);
			}, 500);
		}
	}

	/*Re initialize in specify step*/
	initPosition = (stepNumber: any) => { };

	/*Finish*/
	done = () => {
		let cursoTotorial = JSON.parse(
			this.localStorageService.getItem(LOCALSTORAGESTRINGS.TUTORIALDATA)
		) as TutotrialDataLocal;
		cursoTotorial.sideBarData = true;
		this.loginService.updateDataLocalTutorial(cursoTotorial);
	};

	private _traducirOpciones(): void {
		const lang = this.localStorage.getItem(LOCALSTORAGESTRINGS.LANG);
		this.translateService.use(lang);
	}

	logout(): void {
		this.loginService.logout(true);
	}

	verGrafoAnterior() {
		const targetList: { idGrafo: any; idCurso: any; title: any }[] =
			JSON.parse(this.localStorage.getItem("graphVisited_Student")) || [];
		if (targetList.length === 0) return;

		let pos = 0;
		for (let index = 0; index < targetList.length; index++) {
			if (this.lastTarget === targetList[index].idGrafo) {
				pos = index + 1;
				break;
			}
		}
		if (pos < targetList.length) {
			const previousTarget = targetList[pos];
			this.abrirIdeografo(previousTarget.idGrafo, previousTarget.idCurso);
		}
	}

	verGrafoSiguiente() {
		const targetList: { idGrafo: any; idCurso: any; title: any }[] =
			JSON.parse(this.localStorage.getItem("graphVisited_Student")) || [];
		if (targetList.length === 0) return;

		let pos = 0;
		for (let index = 0; index < targetList.length; index++) {
			if (this.lastTarget === targetList[index].idGrafo) {
				pos = index - 1;
				break;
			}
		}
		if (pos >= 0) {
			const nextTarget = targetList[pos];
			this.abrirIdeografo(nextTarget.idGrafo, nextTarget.idCurso);
		}
	}

	verGrafoAnteriorEditor() {
		const targetList: { idGrafo: any; idCurso: any; title: any }[] =
			JSON.parse(this.localStorage.getItem("graphVisited_Editor")) || [];
		if (targetList.length === 0) return;

		let pos = 0;
		for (let index = 0; index < targetList.length; index++) {
			if (this.lastTarget_Editor === targetList[index].idGrafo) {
				pos = index + 1;
				break;
			}
		}
		if (pos < targetList.length) {
			const previousTarget = targetList[pos];
			this.abrirIdeografo(previousTarget.idGrafo, previousTarget.idCurso);
		}
	}

	verGrafoSiguienteEditor() {
		const targetList: { idGrafo: any; idCurso: any; title: any }[] =
			JSON.parse(this.localStorage.getItem("graphVisited_Editor")) || [];
		if (targetList.length === 0) return;

		let pos = 0;
		for (let index = 0; index < targetList.length; index++) {
			if (this.lastTarget_Editor === targetList[index].idGrafo) {
				pos = index - 1;
				break;
			}
		}
		if (pos >= 0) {
			const nextTarget = targetList[pos];
			this.abrirIdeografo(nextTarget.idGrafo, nextTarget.idCurso);
		}
	}

	abrirIdeografo(idTarget: number, idCourse: number) {
		//Creamos el log
		this.masterService.createActivityHistory(
			"ideografos",
			"Ha entrado en el Ideografo con id: " + idTarget
		);

		if (this.loginService.esAutor()) {
			this.localStorage.setItem('lastTarget_Editor', idTarget);
		} else {
			this.localStorage.setItem('lastTarget', idTarget);
		}
		this.localStorage.removeItem('fromEditor')
		localStorage.setItem('dontLoadMenu', 'true') //Este provoca que no se muestre el menú al cambiar de perfil
		this.utils.loadMenu = false;
		this.graphServ.getGraphInfo(idTarget).subscribe((res) => {
			const viewType = res.data.viewType;
			this.graphServ.changedefaultTypeView(res.data.viewType);
			//ver grafo con nodos y actividades
			if (viewType == 2) {
				this.toolsService.changeVisibility({ nodes: true, quizzes: true });
				//ver grafos solo con ideas
			} else if (viewType == 3) {
				this.toolsService.changeVisibility({ nodes: true, quizzes: false });
				//ver grafo solo con actividades
			} else if (viewType == 4) {
				this.toolsService.changeVisibility({ nodes: false, quizzes: true });
			}
			//this.buscarNodo = JSON.parse(localStorage.getItem("buscarActividad"));
			this.navigateToGraph(idTarget, idCourse);

			if (this.loginService.esAutor()) {
				let historialGrafos_editor = [];
				let localStoredHistory_editor = JSON.parse(
					localStorage.getItem(LOCALSTORAGESTRINGS.GRAPHSHISTORY_EDITOR)
				);
				if (localStoredHistory_editor == null) {
					historialGrafos_editor.push(idCourse);
				} else {
					if (localStoredHistory_editor.length > 15) {
						localStoredHistory_editor.shift(); // Elimina el primer elemento
					}
					localStoredHistory_editor.push(idCourse);
				}
				historialGrafos_editor.push(idCourse);
				this.localStorage.setItem(
					LOCALSTORAGESTRINGS.GRAPHSHISTORY_EDITOR,
					JSON.stringify(
						localStoredHistory_editor == null ? historialGrafos_editor : localStoredHistory_editor
					)
				);
			} else {
				let historialGrafos = [];
				let localStoredHistory = JSON.parse(
					localStorage.getItem(LOCALSTORAGESTRINGS.GRAPHSHISTORY)
				);
				if (localStoredHistory == null) {
					historialGrafos.push(idCourse);
				} else {
					if (localStoredHistory.length > 15) {
						localStoredHistory.shift(); // Elimina el primer elemento
					}
					localStoredHistory.push(idCourse);
				}
				historialGrafos.push(idCourse);
				this.localStorage.setItem(
					LOCALSTORAGESTRINGS.GRAPHSHISTORY,
					JSON.stringify(
						localStoredHistory == null ? historialGrafos : localStoredHistory
					)
				);
			}
			//this.closeModal("Abrir mapa");
			//this.modalService.dismissAll();
			//this.close();
		});
		this.targetsService.registercountopengraph().subscribe((res) => { });
	}
	navigateToGraph(idTarget: number, idCourse: number) {
		this.router
			.navigate([`/course/${idCourse}/graph/${idTarget}`], {
				state: { dontLoadMenu: true },
			})
			.then(() => {
				this.utils.loadMenu = false;
				// this.sigmaCanvasService.setTriggerInitSigma(true);
			});
	}

	verTutoriales() {
		this.tutorialesActivos = !this.tutorialesActivos;
		this.localStorage.setItem("TutorialesON", this.tutorialesActivos);
		this.tutorialService.emitirVerTutoriales2();
		if (this.isModalOpen) {
			this.closeModal();
			this.closeVideoModal();
		} else {
			if (this.tutorialesActivos) {
				let idTutorialContext = this.localStorage.getItem("idTutorialContext");
				this.masterService.openModalTutorial(idTutorialContext);
			}
		}
	}

	verChat() {
		let storedGroupInfo = JSON.parse(localStorage.getItem("selectedGroupInfo"));
		//*** Creamos el log ***
		this.masterService.createActivityHistory(
			"chat",
			"Ha abierto el chat del grupo con id " + storedGroupInfo ? storedGroupInfo.idGroup : 0 + ".",
		);
		//*** Fin del log ***
		this.localStorage.setItem("chatActive", "true");
		this.newMessageChat = false;
	}

	_showUserAccount(event: boolean) {
		this.showIconAgent = event;
	}
}
